<p-confirmDialog #cd key="confirmBox" defaultFocus="reject" [closable]="closeIconButton" 
                 [ngClass]="{'emtr-warning-box': true, 'deactivation-modal-wide': businessJustification}" [ariaLabel]="'Confirmation Dialog'"
                 closeAriaLabel="Close confirmation dialog">
  <ng-template #icon>
    <sdps-icon type="functional" name="error" size="medium" color="error"></sdps-icon>
  </ng-template>
  <ng-template pTemplate="message">
    <div class="container">
    <div class="" [innerHtml]="message"></div>
    <div class ="sdps-business-justification" *ngIf="businessJustification && deactivateClientForm">
      <div class="sdps-text-left">
        <span class="sdps-font-weight-bold" [innerHTML]="sharedConstant.confirmationDialog.businessJustificationTitle"></span>
        <span class="sdps-text-left sdps-text-market-red" [innerHTML]="sharedConstant.confirmationDialog.asterix"></span>
      </div>
    <form [formGroup]="deactivateClientForm">
      <textarea class="p-inputtextarea p-inputtext sdps-p-vertical_x-small group-desc sdps-reason-text" rows="5" cols="50" maxlength="300"
        formControlName="businessJustificationValue" emsCharacterLimit [charMaxLimit]="sharedConstant.charLimitValues.threeHundredMaxLimit"
        (emsCharacterLimitCheck)="showCharLimit = $event" aria-label="Business justification"></textarea>
    </form>
    </div>
 <div *ngIf="deactivateClientForm.get('businessJustificationValue').value && deactivateClientForm.get('businessJustificationValue').value.length >= showCharLimit" class="col-12">
   <p class="sdps-text-right sdps-p-around_none sdps-m-around_none sdps-text-small"
      *ngIf="deactivateClientForm.get('businessJustificationValue').value.length >= showCharLimit">
     {{sharedConstant.characterLimit}}
     <span class="character-limit">{{deactivateClientForm.get('businessJustificationValue').value.length}}/{{sharedConstant.charLimitValues.threeHundredMaxLimit}}</span>
   </p>
 </div>
 <div *ngIf="showDoNotShowAgain" class="sdps-m-top_small" >
   <p-checkbox [(ngModel)]="doNotShowAgain"  [ngModelOptions]="{standalone: true}" binary="true" id="doNotShowAgain"></p-checkbox>
   <label for="doNotShowAgain" class="sdps-m-left_xx-small" [innerHTML]="sharedConstant.dbsAuthAgentMsg.dontShowAgain"></label>
 </div>
</div>
  </ng-template>
  <ng-template pTemplate="footer">
      <button pButton *ngIf="cd.rejectLabel !== 'hideRejectButton'" type="button" class="button cancel-btn" label="{{cd.rejectLabel}}" (click)="cd.onReject()" [disabled]="disableRejectBtn"></button>
        <button pButton *ngIf="cd.acceptLabel !== 'hideAcceptButton'" class="buttons button-save proceed-btn" type="submit" label="{{cd.acceptLabel}}"  (click)="cd.onAccept()" [disabled]="verifyDisable()"></button>
    </ng-template>
</p-confirmDialog>